import type { RouteObject } from 'react-router';
import { MilestonesPage } from './pages/MilestonesPage';
export const milestoneRoutes: RouteObject[] = [
  { path: 'milestone-rewards', element: <MilestonesPage /> },
];
